export default __webpack_public_path__ + "fd755277c74d6a13925f83c908b7153d.svg";